export const videoData = [
  {
    head: 'Ben',
    videoSrc:
      'https://player.vimeo.com/video/939629718?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    videoTitle: 'cp-374310v2-consumer-patient-story-video-2023-ben-1_mJreu6qe'
  },
  {
    head: 'Grace',
    videoSrc:
      'https://player.vimeo.com/video/939618947?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    videoTitle: 'cp-311693v3-spravato-consumer-trd-patient-stories-grace-s-story-1_7w6jvldY"'
  },
  {
    head: 'Allison',
    videoSrc:
      'https://player.vimeo.com/video/939586065?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    videoTitle: 'cp-191060v5-spravato-consumer-trd-patient-stories-allison-s-story-1_xLLpyJuo'
  }
];
